export default {
  members: [
    {
      name: '杨卫华',
      urllink: 'http://ego.geekbang.org/member/detail/36',
      imgUrl: require('../../static/img/member/member_11.png'),
      brief: '多年软件及互联网行业开发经验，2008 年加入新浪，曾负责通讯服务等多个大型后端系统研发...',
      company: '新浪微博',
      profile: '研发副总经理'
    },
    {
      name: '梁宇鹏',
      urllink: 'http://ego.geekbang.org/member/detail/25',
      imgUrl: require('../../static/img/member/member_12.png'),
      brief: '现任环信首席架构师，负责环信即时通讯云后端服务设计。在此之前，作为新浪微博通讯... ',
      company: '环信',
      profile: '首席架构师兼IM事业部总经理'
    },
    {
      name: '范凯',
      urllink: 'http://ego.geekbang.org/member/detail/68',
      imgUrl: require('../../static/img/member/member_13.png'),
      brief: 'JavaEye 开发者社区创始人，前 CSDN 的产品副总裁和 CTO ；比较擅长软件架构设计... ',
      company: '丁香园',
      profile: 'CTO'
    },
    {
      name: '邹光先',
      urllink: 'http://ego.geekbang.org/member/detail/15',
      imgUrl: require('../../static/img/member/member_14.png'),
      brief: '2001 年毕业于电子科技大学获得硕士学位。2004 年至 2007 年，在广州网易互动娱乐...',
      company: '爱拍网络',
      profile: '联合创始人&CTO'
    },
    {
      name: '黄良懿',
      urllink: 'http://ego.geekbang.org/member/detail/18',
      imgUrl: require('../../static/img/member/member_15.png'),
      brief: '写了十几年代码，折腾过好些语言和系统，PHP/C/JAVA 以及 LNMP 做得久些,待过外企...',
      company: 'oppo',
      profile: '数据中心高级总监'
    },
    {
      name: '冯亮',
      urllink: 'http://ego.geekbang.org/member/detail/83',
      imgUrl: require('../../static/img/member/member_16.png'),
      brief: '2002-2005 亚信联创主程，电信行业软件； 2005-2009 趋势科技中国研发中心资深工程师...',
      company: '货车帮',
      profile: '技术合伙人 CTO'
    },
    {
      name: '张新波',
      urllink: 'http://ego.geekbang.org/member/detail/8',
      imgUrl: require('../../static/img/member/member_17.png'),
      brief: '目前在同盾负责技术团队的研发工作，带领团队从零开始构建了一个高可用、可扩展的反欺诈云...',
      company: '同盾科技',
      profile: ' 联合创始人&技术副总裁'
    },
    {
      name: '孔令欣',
      urllink: 'http://ego.geekbang.org/member/detail/12',
      imgUrl: require('../../static/img/member/member_18.png'),
      brief: '美国斯坦福大学获得计算机学和心理学双学位，擅长人机交互（HCI）技术，并担任北大...',
      company: '贝壳金服',
      profile: 'CEO'
    },
    {
      name: '童剑',
      urllink: 'http://ego.geekbang.org/member/detail/276',
      imgUrl: require('../../static/img/member/member_19.png'),
      brief: '童剑先生毕业于北京大学，于光华管理学院获得 MBA 学位；1999 年至 2016 年初就职于新浪... ',
      company: '白山云科技有限公司',
      profile: '联合创始人兼 CTO'
    },
    {
      name: '沈剑',
      urllink: 'http://ego.geekbang.org/member/detail/232',
      imgUrl: require('../../static/img/member/member_20.png'),
      brief: '2009 年－2011 年，百度高级工程师； 2011 年至今，58 集团，58 到家，技术委员会主席...',
      company: '58 到家',
      profile: '技术委员会主席'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/util/member.js